import {
  PauseCircleIcon,
  PlayCircleIcon,
  UserMinusIcon,
} from "@heroicons/react/24/outline";
import {
  CheckCircleIcon,
  ClockIcon,
  DocumentPlusIcon,
  DocumentTextIcon,
  HandThumbUpIcon,
  LockClosedIcon,
  LockOpenIcon,
  PaperAirplaneIcon,
  PencilSquareIcon,
  PlusCircleIcon,
  ShieldCheckIcon,
  TrashIcon,
  TruckIcon,
  UserIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import {
  CheckCheckIcon,
  DollarSign,
  FileCheck,
  FileCog,
  FileText,
  LogOut,
  PackageOpen,
  Rocket,
  ShieldCheck,
  SparklesIcon,
  TrendingUp,
  X,
} from "lucide-react";
import React from "react";

export const TableStatusField = ({ className, status }) => {
  const message = {
    NON_INVITED: "Non Invited",
    INVITED: "Invited",
    IN_REGISTRATION: "In Registration",
    REGISTERD: "Registered",
    REJECT: "Reject",
    DEACTIVATED: "Deactivated",
    IN_RELEASE: "In Release",
    CANCELLED: "Cancelled",
    DELETED: "Deleted",
    PR_APPOVED: "PR Approved",
    ACKNOWLEDGED: "Acknowledged",
    PUBLISHED: "Published",
    QTN_RECEIVED: "QTN Received",
    RFQ_CREATED: "RFQ Created",
    COMERCIAL_APPROVED: "Commercial Approved",
    TECH_APPROVED: "Tech Approved",
    TECHNICAL_OPEN: "Technical Open",
    COMERCIAL_OPEN: "Commercial Open",
    SUBMITTED: "Submitted",
    NEW: "New",
    IN_TRANSIT: "In Transit",
    DISPACHED: "Dispatched",
    GATEPASS_CREATED: "Gatepass Created",
    GRN_CREATED: "GRN Created",
    PENDING_FOR_APPROVAL: "Pending for Approval",
    INVOICE_CANCELLED: "Invoice Cancelled",
    GRN_REJECTED: "GRN Rejected",
    POSTED: "Posted",
    GRN_APPROVED: "GRN Approved",
    ENTRY_SHEET_CREATED: "Entrysheet Created",
    SES_REJECTED: "SES Rejected",
    INVOICE_CREATED: "Invoice Created",
    SES_CANCELLED: "SES Cancelled",
    INVOICE_APPROVED: "Invoice Approved",
    ON_BOARDED: "On Boarded",
    PENDING: "Pending",
    ASN_CANCELLED: "ASN Cancelled",
    GRN_CSNCELLED: "GRN Cancelled",
    APPROVE: "Approve",
    SES_CREATED: "SES Created",
    OPEN: "OPEN",
    CLOSE: "CLOSE",
    PERTIALLY_DISP: "Partially Dispatched",
    FULLY_DISP: "Fully Dispatched",
    APPROVED: "Approved",
    PENDING_WITH_L1: "Pending with L1",
    PENDING_WITH_L2: "Pending with L2",
    COMM_PENDING_WITH_L1: "Commercial Pending with L1",
    COMM_PENDING_WITH_L2: "Commercial Pending with L2",
    KYC_UPDATED: "KYC Updated",
    KYC_PENDING: "KYC Pending",
    Confirmed: "Confirmed",
    InTransit: "InTransit",
    KYC_Approved: "KYC Approved",
    KYC_PendingwithL1: "KYC Pending with L1",
    KYC_PendingwithL2: "KYC Pending with L2",
    Cash_IN_Transit: "Cash in Transit",
    Partial_Amount: "Partial Amount",
    Full_Amount: "Full Amount",
    Not_Received: "Not Received",
    InWard: "InWard",
    OutWard: "OutWard",
    Publish: "Publish",
    Regret: "Regret",
    PO_Created: "PO Created",
    PR_Created: "PR Created",
    IN_PROGRESS: "In Progress",
    CLOSED: "Closed",
    TENDER_CREATED: "Tender Created",
    EST_PENDING: "Estimation Pending",
    EST_DRAFT: "Estimation Draft",
    CREATED: "Created",
    DRAFT: "Draft",
    OFFER_LETTER: "Offer Letter",
    PROMOTION: "Promotion Letter",
    RESIGNATION: "Resignation Letter",
    STARTED: "Started",
    ON_HOLD: "On Hold",
    COMPLETED: "Completed",
    TRANSFERRED: "Transferred",
    PRESENT: "Present",
    ABSENT: "Absent",
    LATE: "Late",
    HOLIDAY: "Holiday",
    LEAVE: "Leave",
  };
  const ICON_SIZE = 16;

  return (
    <>
      {status === message.NON_INVITED ? (
        <span className="bg-table-status-icon bg-table-info-status">
          {status}
          <UserIcon width={16} height={16} color="#4b5563" />
        </span>
      ) : status === message.INVITED ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}
          <PaperAirplaneIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            color="#1d4ed8"
          />
        </span>
      ) : status === message.IN_REGISTRATION ? (
        <span className="bg-table-status-icon bg-table-progress-status">
          {status}
          <ClockIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            color="#d97706"
          />{" "}
        </span>
      ) : status === message.REGISTERD ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <i
            className="bi bi-check-lg"
            style={{ fontSize: 16, color: "#15803d" }}
          ></i>
        </span>
      ) : status === message.REJECT ? (
        <span className="bg-table-status-icon bg-table-danger-status">
          {status}
          <X width={ICON_SIZE} height={ICON_SIZE} color="#15803d" />
        </span>
      ) : status === message.DEACTIVATED ? (
        <span className="bg-table-status-icon bg-table-danger-status">
          {status}
          <XCircleIcon width={16} height={16} color="#dc2626" />
        </span>
      ) : status === message.IN_RELEASE ? (
        <span className="bg-table-status-icon bg-table-progress-status">
          {status}
          <ClockIcon width={16} height={16} color="#d97706" />
        </span>
      ) : status === message.IN_PROGRESS ? (
        <span className="bg-table-status-icon bg-table-progress-status">
          {status}
          <ClockIcon width={16} height={16} color="#d97706" />
        </span>
      ) : status === message.CANCELLED ? (
        <span className="bg-table-status-icon bg-table-danger-status">
          {status}
          <XCircleIcon width={16} height={16} color="#d97706" />
        </span>
      ) : status === message.DELETED ? (
        <span className="bg-table-status-icon bg-table-delete-status">
          {status}
          <TrashIcon width={16} height={16} color="#eb281a" />
        </span>
      ) : status === message.PR_APPOVED ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}{" "}
          <i
            className="bi bi-check-lg"
            style={{ fontSize: 16, color: "#15803d" }}
          ></i>
        </span>
      ) : status === message.ACKNOWLEDGED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}{" "}
          <HandThumbUpIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            color="#15803d"
          />
        </span>
      ) : status === message.PUBLISHED ? (
        <span className="bg-table-status-icon bg-table-publish-status">
          {status}
          <Rocket size={16} color="#1d4ed8" strokeWidth={2.3} />
        </span>
      ) : status === message.QTN_RECEIVED ? (
        <span className="bg-table-status-icon bg-table-progress-status">
          {status}
          <CheckCheckIcon size={16} color="#15803d" strokeWidth={2.3} />
        </span>
      ) : status === message.CANCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.RFQ_CREATED ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}
          <FileCheck size={16} color="#854d0e" strokeWidth={2.3} />
        </span>
      ) : status === message.COMERCIAL_APPROVED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <DollarSign size={16} color="#166534" strokeWidth={2.3} />
        </span>
      ) : status === message.TECH_APPROVED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <ShieldCheck size={16} color="#0f766e" strokeWidth={2.3} />
        </span>
      ) : status === message.TECHNICAL_OPEN ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
          <FileCog size={16} color="#1d9230" strokeWidth={2.3} />
        </span>
      ) : status === message.COMERCIAL_OPEN ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}
          <DollarSign size={16} color="#1d9230" strokeWidth={2.3} />
        </span>
      ) : status === message.SUBMITTED ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}
          <CheckCircleIcon width={16} color="#4f46e5" />
        </span>
      ) : status === message.NEW ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.IN_TRANSIT ? (
        <span className="bg-table-status-icon bg-table-progress-status">
          {status}
          <TruckIcon width={20} height={20} color="#1d4ed8" />
        </span>
      ) : status === message.DISPACHED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <PackageOpen width={20} height={20} color="#1d4ed8" />
        </span>
      ) : status === message.GATEPASS_CREATED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.GRN_CREATED ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}
          <PlusCircleIcon width={16} height={16} color="#15803d" />
        </span>
      ) : status === message.PENDING_FOR_APPROVAL ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.PENDING_FOR_APPROVAL ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.INVOICE_CANCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.GRN_REJECTED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.POSTED ? (
        <span className="bg-table-status bg-table-info-status">{status}</span>
      ) : status === message.GRN_APPROVED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <ShieldCheckIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            color="#15803d"
          />
        </span>
      ) : status === message.GRN_APPROVED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.ENTRY_SHEET_CREATED ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}
          <DocumentPlusIcon width={18} color="#059669" />
        </span>
      ) : status === message.SES_REJECTED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.INVOICE_CREATED ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}
          <DocumentTextIcon width={16} height={16} color="#1d4ed8" />
        </span>
      ) : status === message.SES_CANCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.INVOICE_APPROVED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.ON_BOARDED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.PENDING ? (
        <span className="bg-table-status bg-table-info-status">{status}</span>
      ) : status === message.ASN_CANCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.GRN_CSNCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.APPROVE ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <ShieldCheckIcon width={16} height={16} color="#15803d" />
        </span>
      ) : status === message.SES_CREATED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.OPEN ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}
          <LockOpenIcon width={18} color="#16a34a" />
        </span>
      ) : status === message.PERTIALLY_DISP ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.FULLY_DISP ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.CLOSE ? (
        <span className="bg-table-status-icon bg-table-danger-status">
          {status}
          <LockClosedIcon width={18} color="#374151" />
        </span>
      ) : status === message.APPROVED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.PENDING_WITH_L1 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.PENDING_WITH_L2 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.COMM_PENDING_WITH_L1 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.COMM_PENDING_WITH_L2 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.KYC_UPDATED ? (
        <span className="bg-table-status-icon bg-table-progress-status">
          {status}
          <ShieldCheckIcon width={18} color="#059669" />
        </span>
      ) : status === message.KYC_PENDING ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.Confirmed ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.KYC_Approved ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.KYC_PendingwithL1 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.KYC_PendingwithL2 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.InTransit ? (
        <span className="bg-table-status-icon bg-table-progress-status">
          {status}
          <TruckIcon width={20} height={20} color="#1d4ed8" />
        </span>
      ) : status === message.Cash_IN_Transit ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.Partial_Amount ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.Full_Amount ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.Not_Received ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.InWard ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.OutWard ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.Publish ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.Regret ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.PO_Created ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.PR_Created ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.CLOSED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <LockClosedIcon width={18} color="#374151" />
        </span>
      ) : status === message.TENDER_CREATED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <DocumentPlusIcon width={15} color="#4f46e5" />
        </span>
      ) : status === message.EST_PENDING ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <ClockIcon width={15} color="#4f46e5" />
        </span>
      ) : status === message.OFFER_LETTER ? (
        <span className="bg-table-status-icon bg-table-new-status">
          {status}
          <FileText width={15} color="#16a34a" />
        </span>
      ) : status === message.PROMOTION ? (
        <span className="bg-table-status-icon bg-table-progress-status">
          {status}
          <TrendingUp width={15} color="#2563eb" />
        </span>
      ) : status === message.RESIGNATION ? (
        <span className="bg-table-status-icon bg-table-danger-status">
          {status}
          <LogOut width={15} color="#dc2626" />
        </span>
      ) : status === message.EST_DRAFT ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <PencilSquareIcon width={15} color="#4f46e5" />
        </span>
      ) : status === message.CREATED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <SparklesIcon width={15} color="#4f46e5" />
        </span>
      ) : status === message.DRAFT ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <PencilSquareIcon width={15} color="#4f46e5" />
        </span>
      ) : status === message.STARTED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <PlayCircleIcon width={15} color="#2563eb" />
        </span>
      ) : status === message.ON_HOLD ? (
        <span className="bg-table-status-icon bg-table-warning-status">
          {status}
          <PauseCircleIcon width={15} color="#f59e0b" />
        </span>
      ) : status === message.COMPLETED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <CheckCircleIcon width={15} color="#16a34a" />
        </span>
      ) : status === message.TRANSFERRED ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <CheckCircleIcon width={15} color="#16a34a" />
        </span>
      ) : status === message.PRESENT ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <CheckCircleIcon width={15} color="#16a34a" />
        </span>
      ) : status === message.ABSENT ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <XCircleIcon width={15} color="#dc2626" />
        </span>
      ) : status === message.LATE ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <ClockIcon width={15} color="#f59e0b" />
        </span>
      ) : status === message.HOLIDAY ? (
        <span className="bg-table-status-icon bg-table-success-status">
          {status}
          <ClockIcon width={15} color="#2563eb" />
        </span>
      ) : status === message.LEAVE ? (
        <span className="bg-table-status-icon bg-table-primary-status">
          {status}
          <UserMinusIcon width={15} color="#7c3aed" />
        </span>
      ) : (
        status || "-"
      )}
    </>
  );
};
